import {
  getPathnameByUrl,
  notProtectedRoutes,
  specialCaseRoutes,
  subPermissionRoutes,
  UserPermissionRoutes,
} from "constant/permissions";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
const specialCases = Object.keys(specialCaseRoutes);
function isUserAllowed(user, roleByPath, subPermission) {
  if (user?.role === "super-admin") {
    return true;
  }
  const permissions = user?.roleGroup?.permissions;
  if (notProtectedRoutes?.includes(roleByPath)) {
    return true;
  }

  if (specialCases?.includes(roleByPath)) {
    const permission = permissions?.find((perm) =>
      specialCaseRoutes[roleByPath]?.includes(perm?.main)
    );
    if (!permission) return false;
    if (!subPermission) return true;
    if (subPermissionRoutes[subPermission]) {
      return permissions?.find((perm) =>
        perm?.sub?.includes(subPermissionRoutes[subPermission])
      );
    }
  } else {
    const permission = permissions?.find(
      (perm) => perm?.main === UserPermissionRoutes[roleByPath]
    );

    if (!permission) return false;

    if (!subPermission) return true;
    if (subPermissionRoutes[subPermission]) {
      return permissions?.find(
        (perm) =>
          perm?.main === UserPermissionRoutes[roleByPath] &&
          perm?.sub?.includes(subPermissionRoutes[subPermission])
      );
    }
  }
  return false;
}

function ProtectedRouter({ element: Element, isProtected }) {
  const { isLogin, user } = useSelector((state) => state.authReducer);
  const pathname = useLocation().pathname;
  const [roleByPath, subPermission, subPath] = getPathnameByUrl(pathname);
  const isAllowed = isUserAllowed(
    user,
    roleByPath,
    specialCases?.includes(roleByPath) ? subPath : subPermission
  );

  return (
    <>
      {isLogin ? (
        isAllowed ? (
          Element
        ) : (
          <Navigate replace to="/" />
        )
      ) : isProtected ? (
        <Navigate replace to="/login" />
      ) : (
        Element
      )}
    </>
  );
}
export default ProtectedRouter;
